export default "<app-monitoring-act #monitoringAct></app-monitoring-act>\n<app-compare-plans #comparePlans></app-compare-plans>\n"